import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export type Status = 'running' | 'done' | 'failed' | 'waiting';

const LABEL: Record<Status, string> = {
  running: '生成中',
  done: '完了',
  failed: '失敗',
  waiting: '待機中',
};

export const StatusChip: React.FC<{ status: Status; label?: string }> = ({ status, label }) => (
  <motion.span layout className={`v2-chip v2-chip--${status}`} transition={{ duration: 0.25 }}>
    <span className="v2-chip-dot" />
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.span
        key={label ?? status}
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 0 }}
        transition={{ duration: 0.22 }}
      >
        {label ?? LABEL[status]}
      </motion.span>
    </AnimatePresence>
  </motion.span>
);
